module.exports = __webpack_public_path__ + "static/dockside-private-events-31cd7e5062941378bf0876d86eb16503.pdf";